import { fromJS } from 'immutable';
import { VALUE_CHANGED, LOAD, NEXT, RESET } from './constants';

// The initial state of the App
const initialState = fromJS({
  form: {
    areYouClaimingForRentalVehicleExcess: 'false',
    nameOfThePersonDrivingTheCar: '',
    driverDateOfBirth: '',
    dateOfExpense: '',
    description: 'Rental vehicle excess',
    rentalVehicleExcessAmount: '',
    rentalVehicleExcessAmountCurrency: '',
    actualRepairAmount: '',
    actualRepairAmountCurrency: '',
    amountClaimed: '',
    amountClaimedCurrency: '',
  },
  errors: [],
});
function stepRentalVehicleReducer(state = initialState, action) {
  const properties = action.propertyName ? action.propertyName.split('.') : '';
  switch (action.type) {
    case VALUE_CHANGED: {
      if (
        properties[1] === 'areYouClaimingForRentalVehicleExcess' &&
        action.value === 'false'
      ) {
        return initialState;
      }
      return state.setIn(properties, action.value);
    }
    case LOAD:
      return action.payload
        ? fromJS({ form: action.payload, errors: [] })
        : initialState;
    case NEXT:
      return state.merge({ errors: action.errors });
    case RESET:
      return initialState;
    default:
      return state;
  }
}

export default stepRentalVehicleReducer;



// WEBPACK FOOTER //
// ./app/containers/FastCover/StepRentalVehicle/reducer.js